import { useEffect } from 'react'

import type { ActionPayload, ActionValueMap } from '~/common/@types'

const useHost = <K extends keyof ActionValueMap>(
  action: K,
  callback?: (value: ActionValueMap[K]) => void,
) => {
  useEffect(() => {
    if (!callback) return

    const callbackEvent = (event: MessageEvent<ActionPayload<K>>) => {
      if (event.data.action === action) {
        callback?.(event.data.value)
      }
    }

    window.addEventListener('message', callbackEvent)

    return () => {
      window.removeEventListener('message', callbackEvent)
    }
  }, [action, callback])

  const send = (payload: ActionValueMap[typeof action]) => {
    window.parent.postMessage(
      {
        action,
        value: payload,
      },
      '*',
    )
  }

  return send
}

export default useHost
